<template>
  <router-view />
</template>

<script>
export default {
  name: 'AdministrativeLegalEntitiesIndex'
}
</script>
